import './CSS/ArrowCircleStyle.css';
function ArrowCircle (props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-down-circle Arrowdowncircle" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#f6c90e" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <circle cx="12" cy="12" r="9" />
  <line x1="8" y1="12" x2="12" y2="16" />
  <line x1="12" y1="8" x2="12" y2="16" />
  <line x1="16" y1="12" x2="12" y2="16" />
</svg>         
    );
  }
  
  export default ArrowCircle;
  